import styled            from 'styled-components';

import { themeColors, 
         Typo,
         themeTypos,
         typoAsCSS,      
         cssFlexRow,   
         cssFlexColumn } from 'src/providers/theme/shared';



type InfoItemsListLookAndFeel = {
  paddings: number[];
  innerGap: number;
  listGap: number;
  iconSize: number;
  iconMargin: number;

  placeholderTypo: Typo;
  labelTypo: Typo;

  backgroundColor: string;
  borderColor: string;
  borderRadius: number;
  iconColor: string;
  placeholderColor: string;
  labelColor: string;
}

const infoitemlist_light: InfoItemsListLookAndFeel = {
  paddings: [16, 18, 16, 18],
  innerGap: 8,
  listGap: 1,
  iconSize: 40,
  iconMargin: 2,

  placeholderTypo: themeTypos.GRTSKREG_W400_S12_LH16,
  labelTypo: themeTypos.GRTSKREG_W400_S12_LH16,

  backgroundColor: themeColors.PrimaryWhite,
  borderColor: themeColors.BorderSecondary,
  borderRadius: 16,
  iconColor: themeColors.AccentPrimaryBlueCobolt01,
  placeholderColor: themeColors.TextNeutralText50,
  labelColor: themeColors.TextAccentBlueCobolt100,
}

export type InfoItemsListVariants = 'light';

export const infoitemslist_variants: Map<InfoItemsListVariants, InfoItemsListLookAndFeel> = 
  new Map<InfoItemsListVariants, InfoItemsListLookAndFeel>([
    ['light', infoitemlist_light],
  ]);

export const ItemList = styled.div<{
  lookAndFeel: InfoItemsListLookAndFeel
}>`
  ${cssFlexColumn};
  width: 100%;
  gap: ${(args) => args.lookAndFeel.listGap}px;
  background-color: ${(args) => args.lookAndFeel.borderColor};
  border: 1px solid ${(args) => args.lookAndFeel.borderColor};
  border-radius: ${(args) => args.lookAndFeel.borderRadius}px;

  /* Для первого элемента закругляем верх */
  > *:first-child {
    border-top-left-radius: ${(args) => args.lookAndFeel.borderRadius}px;
    border-top-right-radius: ${(args) => args.lookAndFeel.borderRadius}px;
  }
    
  /* Для последнего элемента закругляем низ */
  > *:last-child {
    border-bottom-left-radius: ${(args) => args.lookAndFeel.borderRadius}px;
    border-bottom-right-radius: ${(args) => args.lookAndFeel.borderRadius}px;
  }
`

export const Container = styled.div<{
  lookAndFeel: InfoItemsListLookAndFeel,
}>`
  ${cssFlexRow};
  width: 100%;
  gap: ${(args) => args.lookAndFeel.innerGap}px;
  padding: ${(args) => args.lookAndFeel.paddings[0]}px
           ${(args) => args.lookAndFeel.paddings[1]}px
           ${(args) => args.lookAndFeel.paddings[2]}px
           ${(args) => args.lookAndFeel.paddings[3]}px;

  background-color: ${(args) => args.lookAndFeel.backgroundColor};
  align-items: center;
`

export const LabelStack = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 2;
  gap: 4px;
`;

export const Placeholder = styled.span<{
  lookAndFeel: InfoItemsListLookAndFeel,
}>`
  flex-grow: 1;
  ${(args) => typoAsCSS(args.lookAndFeel.placeholderTypo)};

  color: ${(args) => args.lookAndFeel.placeholderColor};
`;

export const Label = styled.span<{
  lookAndFeel: InfoItemsListLookAndFeel
}>`
  flex-grow: 2;
  ${(args) => typoAsCSS(args.lookAndFeel.labelTypo)};

  color: ${(args) => args.lookAndFeel.labelColor};
`;

export const Icon = styled.span<{
  lookAndFeel: InfoItemsListLookAndFeel,
}>`
  ${cssFlexRow};
  width: ${(args) => args.lookAndFeel.iconSize}px;
  height: ${(args) => args.lookAndFeel.iconSize}px;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  margin: ${(args) => args.lookAndFeel.iconMargin}px;

  color: ${(args) => args.lookAndFeel.iconColor};
`;